export enum LoteStatus {
  DISPONIVEL = 'DISPONIVEL',
  DESMEMBRAMENTO = 'DESMEMBRAMENTO',
  REMEMBRAMENTO = 'REMEMBRAMENTO',
  INDISPONIVEL = 'INDISPONIVEL',
  CADASTRO = 'CADASTRO',
  CADASTRO_MULTIPLO = 'CADASTRO_MULTIPLO'
}
